import { render, staticRenderFns } from "./AscReportAlertWrapper.vue?vue&type=template&id=0a44b0ec&scoped=true&"
import script from "./AscReportAlertWrapper.vue?vue&type=script&lang=js&"
export * from "./AscReportAlertWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscReportAlertWrapper.vue?vue&type=style&index=0&id=0a44b0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a44b0ec",
  null
  
)

export default component.exports